import Vue from 'vue'
import Vuex from 'vuex'
import { login, quicklogin, login_for_customer } from '../api/api'
import { setup } from '../locales/index'
Vue.use(Vuex)
const state = {
  // 当前登录角色
  roles: {},
  // 权限
  authority: {},
  // 当前点击列表
  selecttext: '',
  // 二级列表数据
  secondarydata: '',
  // 路由传参
  routeVal: {},
  // 所有小便签
  titleList: [],
  // 当前小标签
  curPath: '',
  // 导出
  importState: false,
  // 登录状态
  status: ''
}
const mutations = {
  // 普通登录
  queryUser (state, user) {
    state.status = false
    const obj = {
      username: user.username,
      password: user.password,
      key: user.key,
      verifyMsg: user.verifyMsg
    }
    if (!obj.username || !obj.password) {
      user.that.$message('账号或密码不能为空')
    } else if (obj.verifyMsg.length !== 4) {
      user.that.$message('请输入4位验证码')
    } else {
      login(obj).then(res => {
        if (res.data.code === 0) {
          sessionStorage.setItem('access_token', res.data.data.token)
          sessionStorage.setItem('store', JSON.stringify(res.data.data.user))
          state.roles = res.data.data.user
          state.authority = res.data.data.user.func
          user.that.$router.push('/home')
          const lang = res.data.data.user.lang
          setup(lang)
        } else {
          state.status = true
          const code = res.data.code
          user.that.$message(window.i18n.t(`status[${code}]`))
        }
      })
    }
  },
  // 快速登录
  queryUser2 (state, user) {
    state.status = false
    const obj = {
      username: user.username,
      password: user.password,
      key: user.key,
      verifyMsg: user.verifyMsg
    }
    if (!obj.username || !obj.password) {
      user.that.$message('账号或密码不能为空')
    } else if (obj.verifyMsg.length > 0 && obj.verifyMsg.length !== 4) { // 如果输入，则检查长度
      user.that.$message('请输入4位验证码')
    } else {
      quicklogin(obj).then(res => {
        if (res.data.code === 0) {
          sessionStorage.setItem('access_token', res.data.data.token)
          sessionStorage.setItem('store', JSON.stringify(res.data.data.user))
          state.roles = res.data.data.user
          state.authority = res.data.data.user.func
          user.that.$router.push('/home')
          const lang = res.data.data.user.lang
          setup(lang)
        } else {
          state.status = true
          const code = res.data.code
          user.that.$message(window.i18n.t(`status[${code}]`))
        }
      })
    }
  },
  // 客户单位登录，2026-6 追加，用来和RCN门户网站对接
  queryUserForCustomer (state, user) {
    state.status = false
    const obj = {
      username: user.username,
      password: user.password,
      key: user.key,
      verifyMsg: user.verifyMsg
    }
    if (!obj.username || !obj.password) {
      user.that.$message('账号或密码不能为空')
    } else if (obj.verifyMsg.length !== 4) {
      user.that.$message('请输入4位验证码')
    } else {
      login_for_customer(obj).then(res => {
        if (res.data.code === 0) {
          // sessionStorage.setItem('access_token', res.data.data.token)
          // sessionStorage.setItem('store', JSON.stringify(res.data.data.user))
          // state.roles = res.data.data.user
          // state.authority = res.data.data.user.func
          // user.that.$router.push('/home')
          // const lang = res.data.data.user.lang
          // setup(lang)

          // 跳转到RCN门户网站的回调地址
          window.location.href = res.data.data.redirect_url;
        } else {
          state.status = true
          const code = res.data.code
          user.that.$message(window.i18n.t(`status[${code}]`))
        }
      })
    }
  },
  clearuser (state) {
    state.titleList = []
    state = {}
    state.curPath = ''
  },
  // 左侧导航当前点击的栏目
  leveltext (state, val) {
    state.selecttext = val
  },
  // 左侧导航二级选项数据
  secondarylist (state, user) {
    state.secondarydata = user
  },
  // 获取路由参数
  quertRouteVal (state, val) {
    state.routeVal = val
  },
  // 获取便签
  queryTitle (state, val) {
    state.titleList.push(val)
  },
  setCurPath (state, val) {
    state.curPath = val
  },
  // 导出
  importList (state) {
    state.importState = Math.random(0, 1)
  }
}
const getters = {
}
export default new Vuex.Store({
  state,
  mutations,
  getters
})
